<template>
  <v-menu
    :close-on-content-click="false"
    full-width
    lazy
    min-width="290px"
    offset-y
    transition="scale-transition"
    v-bind="$attrs"
    v-model="menu"
  >
    <v-text-field
      :clearable="canClear"
      :value="value"
      append-icon="event"
      readonly
      slot="activator"
      v-bind="$attrs"
      v-model="date"
      v-on="$listeners"
    ></v-text-field>

    <v-date-picker
      :type="type"
      @input="menu = false"
      locale="ja"
      v-bind="$attrs"
      v-model="date"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: ['value', 'type'],
  data() {
    return {
      menu: false,
      date: null,
    }
  },
  methods: {},
  created() {
    if (this.value) this.date = this.value
  },
  computed: {
    canClear() {
      if (this.$attrs.clearable === undefined) return true
      return this.$attrs.clearable
    },
  },
  watch: {
    value(val) {
      this.date = val
    },
    date() {
      this.$emit('input', this.date)
    },
  },
}
</script>
